export default __webpack_public_path__ + "static/media/Vector (3).ee6fb0d7.svg";